import {
  EMAILTEMPLATES_REQUEST, EMAILTEMPLATES_SUCCESS, EMAILTEMPLATES_FAILURE,
  EMAILTEMPLATE_REQUEST, EMAILTEMPLATE_SUCCESS, EMAILTEMPLATE_FAILURE,
  EMAILTEMPLATE_ADD_REQUEST, EMAILTEMPLATE_ADD_SUCCESS, EMAILTEMPLATE_ADD_FAILURE,
  EMAILTEMPLATE_UPDATE_REQUEST, EMAILTEMPLATE_UPDATE_SUCCESS, EMAILTEMPLATE_UPDATE_FAILURE,
  EMAILTEMPLATE_DELETE_REQUEST, EMAILTEMPLATE_DELETE_SUCCESS, EMAILTEMPLATE_DELETE_FAILURE,
  EMAILTEMPLATE_RESET
} from '../actions/emailTemplates'

const INITIAL_STATE = {
  emailTemplates: null, 
  emailTemplatesNeedRefresh: false, 
  emailTemplate: null, 
  error: null,
  loading: false
}

const emailTemplatesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EMAILTEMPLATES_REQUEST:
      return {
        ...state,
        emailTemplates: null, 
        error: null, 
        loading: true
      }
    case EMAILTEMPLATES_SUCCESS:
      return {
        ...state,
        emailTemplates: action.response, 
        emailTemplatesNeedRefresh: false,
        error: null, 
        loading: false
      }
    case EMAILTEMPLATES_FAILURE:
      return {
        ...state,
        error: action.error, 
        loading: false
      }
    case EMAILTEMPLATE_REQUEST:
      return {
        ...state,
        error: null, 
        loading: true
      }
    case EMAILTEMPLATE_SUCCESS:
      return {
        ...state,
        emailTemplate: action.response, 
        error: null, 
        loading: false
      }
    case EMAILTEMPLATE_FAILURE:
      return {
        ...state,
        error: action.error, 
        loading: false
      }
    case EMAILTEMPLATE_ADD_REQUEST:
      return {
        ...state,
        error: null, 
        loading: true
      }
    case EMAILTEMPLATE_ADD_SUCCESS:
      return {
        ...state,
        emailTemplate: action.response, 
        emailTemplatesNeedRefresh: true, 
        error: null,
        loading: false
      }
    case EMAILTEMPLATE_ADD_FAILURE:
      return {
        ...state,
        error: action.error, 
        loading: false
      }
    case EMAILTEMPLATE_UPDATE_REQUEST:
      return {
        ...state,
        error: null, 
        loading: true
      }
    case EMAILTEMPLATE_UPDATE_SUCCESS:
      return {
        ...state,
        emailTemplate: action.response, 
        emailTemplatesNeedRefresh: true, 
        error: null,
        loading: false
      }
    case EMAILTEMPLATE_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error, 
        loading: false
      }
    case EMAILTEMPLATE_DELETE_REQUEST:
      return {
        ...state,
        error: null, 
        loading: true
      }
    case EMAILTEMPLATE_DELETE_SUCCESS:
      return {
        ...state,
        emailTemplatesNeedRefresh: true, 
        error: null,
        loading: false
      }
    case EMAILTEMPLATE_DELETE_FAILURE:
      return {
        ...state,
        error: action.error, 
        loading: false
      }
    case EMAILTEMPLATE_RESET:
      return {
        ...state,
        emailTemplate: null, 
        error: null, 
        loading: false
      }
    default:
      return state
  }
}

export default emailTemplatesReducer
